module.exports = __webpack_public_path__ + "static/media/111935502.3a6c4d2e.png";